export const EMAIL = "mandeep@pfgs.com.au"

export const ADMIN_EMAIL = (formData) => `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Admin Notification</title>
  <style>
    #email-body {
      margin: 0;
      padding: 0;
      background-image: url('https://pfgs.com.au/background.png');
      background-size: cover;
      background-repeat: no-repeat;
      font-family: Inter, sans-serif;
    }

    .container {
      max-width: 600px;
      margin: auto;
      padding: 40px 20px;
    }

    .logo {
      width: 227.5px;
      height: 60px;
      object-fit: contain;
      margin-bottom: 30px;
    }

    .title {
font-family: 'Inter', sans-serif;

      font-weight: 600;
      font-size: 20px;
      line-height: 150%;
      color: black;
    }

    .desc {
font-family: 'Inter', sans-serif;

      font-weight: 400;
      font-size: 20px;
      line-height: 150%;
      color: black;
      margin: 12px 0 32px 0;
    }

    .item {
font-family: 'Inter', sans-serif;

      display: flex;
      align-items: center;
      height: 45px;
      padding-top: 15px;
      border-bottom: 1px solid #0000001A;
      font-size: 20px;
      line-height: 150%;
    }

    .item strong {
font-family: 'Inter', sans-serif;

      width: 160px;
      font-weight: 600;
      color: black;
    }

    .item span {
font-family: 'Inter', sans-serif;

      font-weight: 400;
      color: black;
    }

    .message {
    font-family: 'Inter', sans-serif;
      padding-top: 20px;
      font-size: 20px;
      line-height: 150%;
      font-weight: 400;
      color: black;
    }

    .button-wrapper {
      margin: 40px 0;
    }

    .reply-button {
      font-family: 'Inter', sans-serif;
      background-color: #00CED1;
      border: none;
      padding: 0 24px;
      height: 64px;
      max-width: 520px;
      width: 100%;
      font-size: 18px;
      font-weight: 600;
      cursor: pointer;
      border-radius: 100px;
      box-shadow: 4px 4px 10px 0px #0000001A;
      font-weight: 400;
      color: black !important;
      height: 42px;
      padding-top: 14px;
      text-align: center;
      text-decoration: none;
      display: block;
    }

    .footer {
      font-family: 'Inter', sans-serif;
      font-size: 18px;
      line-height: 150%;
      color: black;
    }

    .footer strong {
font-family: 'Inter', sans-serif;

      display: block;
      margin-top: 12px;
      font-weight: 600;
    }

    @media screen and (max-width: 470px) {
      .item {
        flex-direction: column;
        align-items: flex-start;
        height: auto;
        padding: 10px 0;
      }

      .item strong {
        width: auto;
        margin-bottom: 5px;
      }
    }
  </style>
</head>
<body id="email-body">
  <div class="container">
    <img src="https://pfgs.com.au/logo.png" alt="Progressive Financial" class="logo" />
    
    <div class="title">Hi Admin,</div>
    <div class="desc">
      You’ve received a new inquiry via the website contact form. Here are the submitted details:
    </div>

    <div class="item"><strong>Full Name</strong><span>${formData.fullName}</span></div>
    <div class="item"><strong>Email</strong><span>${formData.email}</span></div>
    <div class="item"><strong>Phone Number</strong><span>${formData.fullName}</span></div>
    <div class="item"><strong>Service</strong><span>${formData.service}</span></div>

    <div class="item" style="border-bottom: none; display: block; height: auto; margin-top: 5px;">
      <strong>Message</strong>
      <div class="message">
        ${formData.message}
      </div>
    </div>

    <div class="button-wrapper">
        <a href="mailto:${formData.email}" class="reply-button">
    Reply to User
    </a>
    </div>

    <div class="footer">
      You can follow up with the user at your earliest convenience.<br />
      <strong>Thank You,<br />PFGS Website Notification System</strong>
    </div>
  </div>
</body>
</html>
`